var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "email",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.586,
    height: 10.586,
    viewBox: "0 0 10.586 10.586",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M0,0H10.586V10.586H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M2.441,3h7.94a.441.441,0,0,1,.441.441V10.5a.441.441,0,0,1-.441.441H2.441A.441.441,0,0,1,2,10.5V3.441A.441.441,0,0,1,2.441,3Zm7.5,1.869L6.443,8,2.882,4.86v5.2H9.94ZM3.108,3.882l3.33,2.939L9.72,3.882Z",
    transform: "translate(-1.118 -1.677)",
    fill: "gray"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.1613c3e2816e38903c718f354c11c299.svg";
export { ForwardRef as ReactComponent };